import { connect } from 'react-redux'
import Search from './Search'
import { fetchSearch, emptySearch } from './actions'
import { actions } from 'features/Cart'
import { push } from 'connected-react-router'
import mostSearched from './mostSearched'

const mapStateToProps = ({ autoComplete, router }) => ({
  ...autoComplete,
  mostSearched,
  router
})

const mapDispatchToProps = dispatch => ({
  fetchSearch: term => dispatch(fetchSearch(term)),
  emptySearch: () => dispatch(emptySearch()),
  addItemCart: body => dispatch(actions.addItem(body)),
  redirect: path => dispatch(push(path))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Search)



// WEBPACK FOOTER //
// ./src/App/Header/Search/SearchContainer.js